import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'executive_function',
    label: 'ExecutiveFunctionReport',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
